import { render, staticRenderFns } from "./NoticeForm.vue?vue&type=template&id=bbfc9570&scoped=true"
import script from "./NoticeForm.vue?vue&type=script&lang=js"
export * from "./NoticeForm.vue?vue&type=script&lang=js"
import style0 from "./NoticeForm.vue?vue&type=style&index=0&id=bbfc9570&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbfc9570",
  null
  
)

export default component.exports